/**
 * @param state {object} Global state
 * @return {object} Domain state
 */
const getDomainState = state => {

    return state.content;
};


/**
 * @param state {object} Global state
 * @return {String[]|array} Content departments
 */
export const getContentDepartments = state => {

    return getDomainState(state)
        .departments;
};
